module.exports = __webpack_public_path__ + "img/tjls-logo-left.c43149e2.png";